import * as Sentry from '@sentry/react';

Sentry.init({
    dsn: import.meta.env.SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
});

const userJson = document.getElementById('user')?.textContent;
const user = JSON.parse(userJson || '');

Sentry.setUser({ id: user.id, username: user.username });
